<template>

  <div id="app">
    <Header v-if="$store.getters.siteDataLoaded"/>
  </div>

</template>

<script>
import Header from './components/Header.vue'
import { setOptions, bootstrap } from 'vue-gtag'

export default {
  name: 'App',
  components:{
    Header
  },
  created(){
      this.$store.dispatch('loadSiteSettings')
  },
  computed:{
    siteLoaded:function () {
        return this.$store.getters.siteDataLoaded
    }
  },
  watch:{
      siteLoaded(newvar, oldvar) {
          this.updateColor()
          this.enableGtag()
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = this.$store.state.globalTheme.FAVICON
    document.getElementsByTagName('head')[0].appendChild(link);
      }

  },
  mounted(){

  },
  methods:{
      updateColor:function() {
        document.documentElement.style.setProperty('--main-color', this.$store.state.globalTheme.DEFAULT_COLOR);
      },
      enableGtag () {
      setOptions({
        config: { id: this.$store.state.globalTheme.GTAGID }
      })
      bootstrap(this.$gtag).then(() => {

      })
    }
  },

}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #161f28;
}

.social-part .fab{
    padding-right:20px;
    padding-top: 15px;
  }

  .fluid-container.footer{
  background: blue;
}
.fluid-container.footer > *:last-child {
    margin-bottom: 0px;
    color: #fff;
}

</style>



// WEBPACK FOOTER //
// src/App.vue